"use strict";

exports.__esModule = true;
exports.default = exports.InputColor = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _clsx = _interopRequireDefault(require("clsx"));
var _colord = require("colord");
var _reactColorful = require("react-colorful");
var _useFormElementValidation = _interopRequireDefault(require("../../hooks/useFormElementValidation"));
var _useRandomId = _interopRequireDefault(require("../../hooks/useRandomId"));
var _Input = _interopRequireDefault(require("./Input"));
var _Tooltip = _interopRequireDefault(require("../Tooltip/Tooltip"));
var _useLabel = _interopRequireDefault(require("../../hooks/useLabel"));
var _Dropdown = _interopRequireDefault(require("../Dropdown/Dropdown"));
var _RadioGroup = _interopRequireDefault(require("../Radio/RadioGroup"));
var _Checkbox = _interopRequireDefault(require("../Checkbox/Checkbox"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * The Input component allows an user to enter data into the application.
 */
const InputColor = props => {
  const {
    id: controlledId,
    name,
    value: controlledValue,
    label: initialLabel,
    placeholder,
    helper,
    clearable,
    readOnly,
    disabled,
    required,
    onChange,
    onError,
    className,
    maxChar,
    displayAsText,
    customValidation,
    customMessage,
    // labelAria,
    withErrorTooltip
  } = props;

  // const inputRef = React.useRef(null);
  const id = _react.default.useRef((0, _useRandomId.default)(controlledId)).current;
  const [value, setValue] = _react.default.useState(controlledValue || '');
  const [withTransparency, setTransparency] = _react.default.useState(false);
  const [errors, methods] = (0, _useFormElementValidation.default)(value, {
    required,
    maxChar,
    customValidation,
    customMessage
  });
  const [mode, setMode] = _react.default.useState();
  const {
    label
  } = (0, _useLabel.default)(initialLabel, {
    ...props,
    id,
    value
  });
  _react.default.useEffect(() => {
    if (controlledValue) {
      if (controlledValue.startsWith('rgba')) {
        setMode("RGB-" + id);
        setTransparency(true);
      } else if (controlledValue.startsWith('rgb')) {
        setMode("RGB-" + id);
        setTransparency(false);
      } else if (controlledValue.startsWith('hsla')) {
        setMode("HSL-" + id);
        setTransparency(true);
      } else if (controlledValue.startsWith('hsl')) {
        setMode("HSL-" + id);
        setTransparency(false);
      } else if (controlledValue.startsWith('#') && controlledValue > 7) {
        setMode("HEX-" + id);
        setTransparency(true);
      } else {
        setMode("HEX-" + id);
        setTransparency(false);
      }
    }
    setValue(controlledValue);
  }, [controlledValue, id]);
  _react.default.useEffect(() => {
    if (typeof onError === 'function') {
      onError({
        name: name || id,
        errors: errors.length ? errors : []
      });
    }
  }, [errors, onError, name, id]);
  const handleChange = value => {
    if (typeof onChange === 'function') {
      onChange(value || '', name || id);
    }
    setValue(value);
    methods.onChange(value);
  };
  const handleOnClear = () => {
    setValue('');
    methods.onChange('');
    if (typeof onChange === 'function') {
      onChange('', name || id);
    }
  };
  const containerClasses = (0, _clsx.default)('uk-form-item', 'uk-input', 'uk-input--color',
  // (clearable || icon?.length) && 'has-icon',
  // icon?.length && `has-icon--${iconPosition}`,
  // addon && 'has-info',
  // addon && `has-info--${addonPosition}`,
  helper.length > 0 && 'has-helper', (errors.length > 0 || disabled || readOnly) && 'is-frozen', errors.length > 0 && 'has-error', errors.length > 0 && withErrorTooltip && 'has-error--tooltip', clearable && value && 'is-clearable', className);

  // const positionLabel = addon && !floatLabel;

  const handleChangeMode = mode => {
    const newMode = mode.split('-')[0];
    let newColor;
    if (newMode === 'HEX') {
      newColor = (0, _colord.colord)(value).toHex();
    }
    if (newMode === 'RGB') {
      newColor = (0, _colord.colord)(value).toRgbString();
    }
    if (newMode === 'HSL') {
      newColor = (0, _colord.colord)(value).toHslString();
    }
    setMode(mode);
    setValue(newColor);
    if (typeof onChange === 'function') {
      onChange(newColor || '', name || id);
    }
  };
  const handleChangeTransparency = transparent => {
    let newColor;
    if (mode.split('-')[0] === 'HEX') {
      newColor = transparent ? (0, _colord.colord)(value).alpha(0.5).toHex() : (0, _colord.colord)(value).alpha(1).toHex();
    }
    if (mode.split('-')[0] === 'RGB') {
      newColor = transparent ? (0, _colord.colord)(value).alpha(0.5).toRgbString() : (0, _colord.colord)(value).alpha(1).toRgbString();
    }
    if (mode.split('-')[0] === 'HSL') {
      newColor = transparent ? (0, _colord.colord)(value).alpha(0.5).toHslString() : (0, _colord.colord)(value).alpha(1).toHslString();
    }
    setTransparency(transparent);
    setValue(newColor);
    if (typeof onChange === 'function') {
      onChange(newColor || '', name || id);
    }
  };
  const innerPlaceholder = mode ? withTransparency ? mode.split('-')[0] === 'HEX' ? '#XXXXXXXX' : mode.split('-')[0] === 'RGB' ? 'rgba(X, X, X, X)' : 'hsla(X, X%, X%, X)' : mode.split('-')[0] === 'HEX' ? '#XXXXXX' : mode.split('-')[0] === 'RGB' ? 'rgb(X, X, X)' : 'hsl(X, X%, X%)' : '';
  if (displayAsText) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: containerClasses
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "flex-container"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "uk-input--color__thumb",
      style: {
        background: value || 'transparent'
      }
    }), /*#__PURE__*/_react.default.createElement("span", null, value || '')));
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    className: containerClasses
  }, label, /*#__PURE__*/_react.default.createElement("div", {
    className: "flex-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "uk-form-item__field"
  }, /*#__PURE__*/_react.default.createElement(_Dropdown.default, {
    tabIndex: "-1",
    align: "right",
    disabled: disabled,
    trigger: /*#__PURE__*/_react.default.createElement("div", {
      className: "uk-dropdown__input"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "uk-input--color__thumb",
      style: {
        background: value || 'transparent'
      }
    }), /*#__PURE__*/_react.default.createElement(_Input.default, {
      placeholder: placeholder,
      readOnly: true,
      tabIndex: "0",
      value: value || '',
      "aria-label": label,
      "aria-describedby": (name || id) + "-helper-text"
    }), /*#__PURE__*/_react.default.createElement("div", {
      "aria-hidden": "true",
      className: "uk-input__clearButton right",
      onClick: handleOnClear
    }, "\xD7"), errors.length > 0 && withErrorTooltip && /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
      trigger: "!",
      className: "uk-form-item__error-tooltip"
    }, /*#__PURE__*/_react.default.createElement("div", {
      id: (name || id) + "-errors-text"
    }, errors)))
  }, /*#__PURE__*/_react.default.createElement(_RadioGroup.default, {
    name: "mode-" + id,
    id: "mode-" + id,
    className: "uk-form-field",
    checked: mode,
    onChange: handleChangeMode,
    options: [{
      label: 'HEX',
      value: 'HEX',
      id: "HEX-" + id
    }, {
      label: 'RGB',
      value: 'RGB',
      id: "RGB-" + id
    }, {
      label: 'HSL',
      value: 'HSL',
      id: "HSL-" + id
    }]
  }), /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
    id: "transparency-" + id,
    checked: withTransparency,
    onChange: handleChangeTransparency,
    label: 'Allow transparency'
  }), mode && /*#__PURE__*/_react.default.createElement(_Input.default, {
    placeholder: innerPlaceholder,
    value: value || '',
    onChange: handleChange
  }), mode && mode.split('-')[0] === 'HEX' && !withTransparency && /*#__PURE__*/_react.default.createElement(_reactColorful.HexColorPicker, {
    color: value,
    onChange: handleChange
  }), mode && mode.split('-')[0] === 'RGB' && !withTransparency && /*#__PURE__*/_react.default.createElement(_reactColorful.RgbStringColorPicker, {
    color: value,
    onChange: handleChange
  }), mode && mode.split('-')[0] === 'HSL' && !withTransparency && /*#__PURE__*/_react.default.createElement(_reactColorful.HslStringColorPicker, {
    color: value,
    onChange: handleChange
  }), mode && mode.split('-')[0] === 'HEX' && withTransparency && /*#__PURE__*/_react.default.createElement(_reactColorful.HexAlphaColorPicker, {
    color: value,
    onChange: handleChange
  }), mode && mode.split('-')[0] === 'RGB' && withTransparency && /*#__PURE__*/_react.default.createElement(_reactColorful.RgbaStringColorPicker, {
    color: value,
    onChange: handleChange
  }), mode && mode.split('-')[0] === 'HSL' && withTransparency && /*#__PURE__*/_react.default.createElement(_reactColorful.HslaStringColorPicker, {
    color: value,
    onChange: handleChange
  })))), errors.length > 0 && !withErrorTooltip && /*#__PURE__*/_react.default.createElement("span", {
    className: "uk-form-item__error",
    id: (name || id) + "-errors-text"
  }, errors), errors.length > 0 && !withErrorTooltip ? '' : helper.length > 0 && /*#__PURE__*/_react.default.createElement("small", {
    className: "uk-form-item__helper",
    id: (name || id) + "-helper-text"
  }, helper));
};
exports.InputColor = InputColor;
InputColor.propTypes = {
  /**
   * ID of the Input (used to bind the label to the Input)
   * NB: the ID will be randomly generated if not set.
   */
  id: _propTypes.default.string,
  /**
   * Name of the Input (used instead of the ID when submitted)
   */
  name: _propTypes.default.string,
  /**
   * Default value of the Input
   */
  value: _propTypes.default.string,
  /**
   * Label of the Input
   */
  label: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.element]),
  /**
   * Input placeholder
   */
  placeholder: _propTypes.default.string,
  /**
   * Helper text, is replaced by a message in case of error
   */
  helper: _propTypes.default.string,
  /**
   * Add a button to clear the Input
   */
  clearable: _propTypes.default.bool,
  /**
   * Set the Input as read-only
   */
  readOnly: _propTypes.default.bool,
  /**
   * Set the Input as disabled
   */
  disabled: _propTypes.default.bool,
  /**
   * Form-validation: set the Input as required
   */
  required: _propTypes.default.bool,
  /**
   * Callback function onChange
   */
  onChange: _propTypes.default.func,
  /**
   * Callback function onError
   */
  onError: _propTypes.default.func,
  /**
   *
   */
  maxChar: _propTypes.default.number,
  /**
   * Display the value as a text, wrapped in <span/>
   */
  displayAsText: _propTypes.default.bool,
  /**
   * Add a custom validation with a regex
   */
  customValidation: _propTypes.default.oneOfType([_propTypes.default.objectOf(_propTypes.default.instanceOf(RegExp)), _propTypes.default.func]),
  /**
   * Add a custom message when custom validation is used
   */
  customMessage: _propTypes.default.object,
  /**
   * Provide text to labelAria only if props label is omitted.
   */
  labelAria: _propTypes.default.string,
  /**
   * Display error in tooltip otherwise display error below input.
   */
  withErrorTooltip: _propTypes.default.bool
};
InputColor.defaultProps = {
  helper: '',
  readOnly: false,
  clearable: false,
  disabled: false,
  required: false,
  withErrorTooltip: true,
  displayAsText: false
};
var _default = exports.default = InputColor;